import { render, staticRenderFns } from "./NewSocialUnit.vue?vue&type=template&id=af4c18f2&scoped=true"
import script from "./NewSocialUnit.vue?vue&type=script&lang=js"
export * from "./NewSocialUnit.vue?vue&type=script&lang=js"
import style0 from "./NewSocialUnit.vue?vue&type=style&index=0&id=af4c18f2&prod&lang=css"
import style1 from "./NewSocialUnit.vue?vue&type=style&index=1&id=af4c18f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4c18f2",
  null
  
)

export default component.exports